import { createStyles } from 'antd-style';

const useStyles = createStyles(({ token }) => ({
  cmdDialog: {
    maxWidth: '640px',
    width: '100%',
    background: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadow,
    margin: '0 auto',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  cmdContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '0',
  },
  cmdInput: {
    width: '100%',
    padding: '12px',
    border: 'none',
    outline: 'none',
    fontSize: token.fontSizeLG,
    background: token.colorBgElevated,
  },
  cmdList: {
    maxHeight: '400px',
    overflowY: 'auto',
    padding: '8px',
  },
  cmdEmpty: {
    padding: '12px',
    textAlign: 'center',
    color: token.colorTextSecondary,
  },
  cmdGroup: {
    padding: '4px 0',
  },
  cmdItem: {
    padding: '8px 12px',
    borderRadius: token.borderRadiusSM,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      background: token.colorBgTextHover,
    },
    '&[data-selected="true"]': {
      background: token.colorBgTextHover,
    },
  },
  cmdShortcuts: {
    display: 'flex',
    gap: '4px',
    '& kbd': {
      padding: '2px 6px',
      background: token.colorBgTextActive,
      borderRadius: token.borderRadiusSM,
      fontSize: token.fontSizeSM,
    },
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${token.colorBorder}`,
    padding: '0 12px',
  },
}));

export { useStyles };
